var flexFractions = {
    1: '8.33%',
    2: '16.67%',
    3: '25%',
    4: '33.33%',
    5: '41.67%',
    6: '50%',
    7: '58.33%',
    8: '66.67%',
    9: '75%',
    10: '83.33%',
    11: '91.67%',
    12: '100%',
};
function getFlexBasis(size) {
    if (size) {
        if (size === 'auto')
            return size;
        return flexFractions[size];
    }
    return 'none';
}
export default getFlexBasis;
